module.exports = __webpack_public_path__ + "media/images/team/steffen-boller-194b6875de0a92442c0f7a630a30a9f2.png";